import React from 'react';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { dataAttrs } from 'Helpers/Testing';
import { FDBox } from '@facet-wealth/design';
import metaOverrideSet from './MetaOverrideSet';


export const HelpTextItem = ({ resource }) => {
  return (
    <FDBox {...dataAttrs('risk-tolerance-help-text-summary')}>
      <MetaControl attrName={'name'} resource={resource} metaOverrideSet={metaOverrideSet} />
      <MetaControl attrName={'description'} resource={resource} metaOverrideSet={metaOverrideSet} />
    </FDBox>
  );
};

HelpTextItem.propTypes = {
  resource: PropTypes.object.isRequired,
};
